import React from 'react';

/**
 * Bloques de carga (shimmer) — usan el token semántico `skeleton` (claro/oscuro).
 * Composables: Skeleton (bloque), SkeletonRows (lista/tabla), SkeletonCards (rejilla).
 */
export const Skeleton: React.FC<{ className?: string; style?: React.CSSProperties }> = ({
  className = '',
  style,
}) => <div className={`animate-pulse rounded-md bg-skeleton ${className}`} style={style} />;

/** Filas de lista/tabla genéricas. */
export const SkeletonRows: React.FC<{ rows?: number; className?: string }> = ({
  rows = 6,
  className = '',
}) => (
  <div className={`space-y-2 ${className}`}>
    {Array.from({ length: rows }).map((_, i) => (
      <Skeleton key={i} className="h-12 w-full" />
    ))}
  </div>
);

/** Rejilla de tarjetas (p.ej. KPIs). */
export const SkeletonCards: React.FC<{ count?: number; className?: string }> = ({
  count = 6,
  className = 'grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3',
}) => (
  <div className={className}>
    {Array.from({ length: count }).map((_, i) => (
      <Skeleton key={i} className="h-24 w-full rounded-lg" />
    ))}
  </div>
);

export default Skeleton;
